import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    BooleanField,
    EditButton,
    ShowButton,
    Filter,
    SearchInput,
} from 'react-admin';
import {
    Edit,
    SimpleForm,
    TextInput,
    BooleanInput,
} from 'react-admin';
import {
    Show,
    SimpleShowLayout,
} from 'react-admin';

const ServiceFilter = () => (
    <Filter>
        <SearchInput source="name" alwaysOn />
        <SearchInput source="category" />
        <SearchInput source="description" />
    </Filter>
);

export const ServiceList = () => (
    <List filters={<ServiceFilter />}>
        <Datagrid>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="category" />
            <TextField source="description" />
            <BooleanField source="is_active" />
            <DateField source="created_at" />
            <EditButton />
            <ShowButton />
        </Datagrid>
    </List>
);

export const ServiceEdit = () => (
    <Edit>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="category" />
            <TextInput source="description" multiline rows={3} />
            <BooleanInput source="is_active" />
        </SimpleForm>
    </Edit>
);

export const ServiceShow = () => (
    <Show>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="name" />
            <TextField source="category" />
            <TextField source="description" />
            <BooleanField source="is_active" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
); 